import type { GeneralSettingsDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GeneralSettingsService {
  apiName = 'Default';
  

  getSettings = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, GeneralSettingsDto>({
      method: 'GET',
      url: '/api/app/general-settings',
    },
    { apiName: this.apiName,...config });
  

  updateSettings = (input: GeneralSettingsDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'PUT',
      url: '/api/app/general-settings',
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
